export var CorrelationVector;
(function (CorrelationVector) {
    var baseHash;
    var baseId = 0;
    /**
     * Get a new correlation vector representing the next event in sequence
     */
    function getNext() {
        if (baseHash === undefined) {
            baseHash = generatePseudoHash();
        }
        return new CV(baseHash, ++baseId);
    }
    CorrelationVector.getNext = getNext;
    /**
     * Get a new correlation vector parented to this one
     * @param parent
     */
    function getNextChild(parent) {
        return new CV(parent.getString(), ++parent.nextChild);
    }
    CorrelationVector.getNextChild = getNextChild;
    var CV = /** @class */ (function () {
        function CV(base, id) {
            this.base = base;
            this.id = id;
            this.nextChild = 0;
        }
        CV.prototype.getString = function () {
            return this.base + "." + this.id;
        };
        return CV;
    }());
    CorrelationVector.CV = CV;
    function generatePseudoHash() {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        var hashLength = 22;
        var result = [];
        for (var i = 0; i < hashLength; i++) {
            // tslint:disable: insecure-random (security is not a concern here and secure crypto function is not available on all platform)
            result.push(characters.charAt(Math.floor(Math.random() * characters.length)));
        }
        return result.join('');
    }
})(CorrelationVector || (CorrelationVector = {}));
//# sourceMappingURL=CorrelationVector.js.map